module.exports = "<travel-request-page></travel-request-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/travelRequest.html
// module id = 1928
// module chunks = 0